<template>
    <form>
        <ErrorSummary :response-status="responseStatus" />
        <div class="grid grid-cols-4 gap-6 mt-6">
            <div class="col-span-4 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 " for="firstName">First Name</label>
                <input id="firstName" v-model="accountManagerSettings.firstName"
                    class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                    name="firstName" type="text">
            </div>
            <div class="col-span-4 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 " for="lastName">Last Name</label>
                <input id="lastName" v-model="accountManagerSettings.lastName"
                    class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                    name="lastName" type="text">
            </div>
        </div>
        <div class="mt-4 md:w-1/8">
            <SaButton @click.prevent="submit" :loading="isSubmitting" variant="primary"/>
        </div>


    </form>
    <NotificationSuccess :show="updateSuccessful" content="Your changes were successfully saved."
        title="Successfully saved!" />

</template>

<script lang="ts" setup>
import {onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import {
    GetAccountManagerSettings, 
    GetAccountManagerSettingsResponse,
    UpdateAccountManagerSettings
} from "@/dtos";
import SaButton from "@/main/components/SaButton.vue";

const accountManagerSettings: Ref<GetAccountManagerSettingsResponse> = ref(new GetAccountManagerSettingsResponse());

const responseStatus = ref(null);
const updateSuccessful: Ref<Boolean> = ref(false);

onMounted(async () => {
    await client.get<GetAccountManagerSettingsResponse>(new GetAccountManagerSettings())
        .then(response => {
            accountManagerSettings.value = response;
        });
});

const isSubmitting = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;

    let request = accountManagerSettings.value;

    await client.post<ResponseStatus>(new UpdateAccountManagerSettings(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};

</script>